
import { useState, useEffect } from 'react';

interface PlatformInfo {
  isNative: boolean;
  isIOS: boolean;
  isAndroid: boolean;
  isWeb: boolean;
  platform: string;
}

export function usePlatform(): PlatformInfo {
  const [platformInfo, setPlatformInfo] = useState<PlatformInfo>({
    isNative: false,
    isIOS: false,
    isAndroid: false,
    isWeb: true,
    platform: 'web'
  });

  useEffect(() => {
    const detectPlatform = async () => {
      if (window.Capacitor) {
        const { Capacitor } = await import('@capacitor/core');
        
        if (Capacitor.isNativePlatform()) {
          const platform = Capacitor.getPlatform();
          setPlatformInfo({
            isNative: true,
            isIOS: platform === 'ios',
            isAndroid: platform === 'android',
            isWeb: false,
            platform
          });
        }
      }
    };

    detectPlatform();
  }, []);

  return platformInfo;
}
